<template>
    <div class="search-hints">
        <span class="hint-link" v-if="showNoResultsMessage">{{ localization.noResults }}</span>
        <span class="hint-link" v-if="showLookingForResultsMessage">{{ localization.searching }}</span>
        <a
            v-for="post in posts"
            class="hint-link"
            :href="post.permalink"
        >
            {{post.title}}
        </a>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "SearchHints",
    inject: ['restUri', 'localization'],
    data(){
        return {
            posts: [],
            searchTimeoutId: null
        }
    },
    props: {
        pSearchValue: String
    },
    methods: {
        async makeRequestForHints(){
            return axios.post(this.restEndpointUrl, {
                search: this.pSearchValue
            }).then(response => {
                this.posts = response.data;
            }).catch(reason => {

            }).finally(() => {

            });
        }
    },
    watch: {
        pSearchValue(newValue, prevValue){

            if(newValue + "".trim() !== prevValue){

                //  Cancel any search.
                if(this.searchTimeoutId){
                    clearTimeout(this.searchTimeoutId);
                }

                if(this.shouldSearch){

                    this.posts = [];

                    this.searchTimeoutId = setTimeout(() => {
                        this.makeRequestForHints();
                        this.searchTimeoutId = null;
                    }, 1000);
                }

            }

        }
    },
    computed: {
        restEndpointUrl(){
            return this.restUri + 'cccblog/v1/quicksearch/';
        },
        showNoResultsMessage(){
            return !this.searchTimeoutId && !this.posts.length;
        },
        showLookingForResultsMessage(){
            return this.searchTimeoutId;
        },
        shouldSearch(){
            return this.pSearchValue.length > 2;
        }
    }
}
</script>

<style lang="scss" scoped>
    .search-hints {
        display: block;
        background: white;
        font-size: 12px;
        border: 1px solid #f2f2f2;
        width: 100%;
        position: absolute;
        bottom: 0;
        transform: translateY( 100% );
        color: black;
        z-index: 5;
    }

    .hint-link {
        display: block;
        color: black;
        padding: 0.5em 1em;
        text-decoration: none;

        &[href] {

            &:hover {
                text-decoration: underline;
            }

            color: #0a53be;

        }

        & + & {
            border-top: 1px solid #f2f2f2;
        }
    }
</style>